<template lang="pug">
  .component-array-edit
    .input-group
      selectize-vehicle-attribute.input-group-field(v-model="newName", @optionSelected="setValue")
      .input-group-button
        button.button.fa.fa-plus(@click="addField" :disabled="!newName")

    .prop-item(v-for="value, label in values", v-if="typeof value !== 'undefined'")
      .input-group
        span.input-group-label {{label}}
        input.input-group-field(type='text', v-model="values[label].value")
        .input-group-button
          button.button.warning.fa.fa-times(@click="removeField(label)")
</template>

<script>


  import SelectizeVehicleAttribute from "./lists/selectize/SelectizeVehicleAttribute";

  export default {
    name: 'SelectizeVehicleAttributesArrayEdit',
    components: {SelectizeVehicleAttribute},
    data() {
      return {
        newName: null
      }
    },
    methods: {
      addField() {
        try {
          var values = JSON.parse(`${this.newName}`)
          console.log(values)

          this.newName = null
        } catch (e) {
        console.log(this.newName)
          //this.$set(this.values, this.newName, {value:'--'})
          this.newName = null
          return false;
        }
      },
      removeField(label) {
        this.$delete(this.values, label)
      },
      setValue(obj) {
        this.newName = obj.name
      }
    },
    props: {
      values: {
        type: Object
      }
    }
  }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// SelectizeVehicleAttributesArrayEdit.vue?6f33bf63